module.exports = __webpack_public_path__ + "static/media/discover_bg.b2c016c9.png";